import React from 'react';
import propTypes from 'prop-types';
import FontAwesomIcon from 'react-fontawesome';
import styled from 'styled-components';

const StyledItems = styled.div`
  img{
    float:left;
    width:85%;
    height: 120px;
    border-radius:5px;
  }
  .dec{
    float:left;
    padding-top:10px;
    font-size:12px;
    word-wrap: break-word;
    width: 95%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding-left:0px;
      width:100%;
    };
    strong{
    }
  }
  span{
    line-height:22px;
    b{
      font-weight:normal;
      color: ${(props) => props.theme.mediumGrey};
    }
  }
`;

/**
 * @todo @author vishwadeep
 */
function Items(props) {
  const { cart, childHandler } = props;
  return (
    <StyledItems key={cart.slug}>
      <img
        src={((cart.Delivery && cart.Delivery.length && cart.Delivery[0].image) ? cart.Delivery[0].image : cart.image)}
        alt="img_not_available"
        className="pointer"
        role="representation"
        onClick={() => childHandler('detailsPage', cart.slug, null)}
      />
      <div className="dec">
        <strong className="pointer" onClick={() => childHandler('detailsPage', cart.slug, null)} role="presentation">{cart.title}</strong>
        <div><span><b>Delivery :</b> {cart.Delivery[0].delivery_value}</span></div>
        {
          cart.shipping_address && (
            <span>
              <b>Email: </b>{cart.shipping_address.email}<br />
              <b>Mobile: </b>{cart.shipping_address.phone_numbers[0]}<br />
              <b>Message: </b>{cart.Message}<br />
              {/* <span className="pointer" role="presentation" onClick={() => childHandler('editDetails', null, cart)}><FontAwesomIcon name="edit" title="Edit" /></span> */}
            </span>)
        }
      </div>
    </StyledItems>
  );
}

Items.propTypes = {
  cart: propTypes.object,
  childHandler: propTypes.func,
};

export default Items;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/Items.js